type TreeFilterMap = Record<string, number>;

export const treeFilterMapOptions: TreeFilterMap = {
  and: 1,
  or: 2,
};
